import * as React from 'react';

import { useChatPageMessages } from './hooks/useChatPageMessages';
import { ChatPageLayout } from '../../components/ChatPageLayout';
import { TMessage } from '../../types/messages';
import { IMessagePage } from '../../utils/messageUtils';
import { PrettyDateContainer } from '../PrettyDateContainer';

type TProps = {
  page: IMessagePage;
  setRefInMessagesMap: (r: HTMLDivElement | null, message: TMessage, messageId: string) => void;
};

export const ChatPageContainer: React.FC<TProps> = ({ page, setRefInMessagesMap }) => {
  const { date, messages } = page;

  const { messagesNode } = useChatPageMessages(messages, setRefInMessagesMap);

  return <ChatPageLayout date={<PrettyDateContainer date={date} />} messages={messagesNode} />;
};
